module.exports = __webpack_public_path__ + "static/media/21ECLAC20.10440e58.jpg";